<template>
  <div
    v-if="haveCoordinatedAppointment"
    class="alert bg-secondary-41 px-2 rounded pt-2 mb-n0 alert-container"
  >
    <div class="d-flex align-items-center">
      <em class="fa fa-bell-exclamation font-16 pl-2 ml-1 color-secondary-40" />
      <div class="font-14 font-weight-normal color-secondary-40 ml-3">
        {{ appointmentMessage }}
      </div>
    </div>
  </div>
</template>

<script>
import ServiceTypes from '@/utils/constants/serviceTypes';
import { getAppointment } from '@/services/uspqrp/provisional-remedy.api';

export default {
  name: 'AppointmentNotification',
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      appointmentMessage: null,
      haveCoordinatedAppointment: false,
    };
  },
  computed: {
    canGetAppointment() {
      return (
        this.serviceType === ServiceTypes.Evaluation ||
        this.serviceType === ServiceTypes.Therapy
      );
    },
    serviceType() {
      return this.data.serviceTypeId;
    },
  },
  async mounted() {
    await Promise.all([this.onHaveCoordinatedAppointmentHandler()]);
  },
  methods: {
    async onHaveCoordinatedAppointmentHandler() {
      this.haveCoordinatedAppointment = false;
      this.appointmentMessage = null;
      if (this.canGetAppointment) {
        const { data } = await getAppointment({
          disciplineTypeId: this.data.disciplineTypeId,
          studentSieId: this.data.studentSieId,
        });
        if (data?.appointmentId) {
          const appointmentFormat = this.$options.filters.appointment(
            data.appointmentId.toString()
          );
          this.haveCoordinatedAppointment = true;
          this.appointmentMessage = `El servicio ${this.data.serviceDiscipline} cuenta con una cita coordinada ${appointmentFormat}.`;
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.alert-container {
  margin-bottom: 0px !important;
}
</style>
